import { Calendar, Layers } from 'lucide-react';

interface SeriesDaySelectorProps {
  totalDays: number;
  selectedDay: number;
  sendAllDays: boolean;
  sendCount: number;
  onDaySelect: (day: number) => void;
  onSendAllChange: (sendAll: boolean) => void;
  onSendCountChange: (count: number) => void;
}

export function SeriesDaySelector({
  totalDays,
  selectedDay,
  sendAllDays,
  sendCount,
  onDaySelect,
  onSendAllChange,
  onSendCountChange,
}: SeriesDaySelectorProps) {
  return (
    <div className="bg-void/30 rounded-lg p-3 space-y-3">
      {/* Mode toggle */}
      <div className="flex items-center gap-2">
        <button
          onClick={() => onSendAllChange(false)}
          className={`flex-1 flex items-center justify-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
            !sendAllDays
              ? 'bg-rune/20 text-rune border border-rune/30'
              : 'text-mist hover:text-parchment border border-transparent'
          }`}
        >
          <Calendar size={12} />
          Single Day
        </button>
        <button
          onClick={() => onSendAllChange(true)}
          className={`flex-1 flex items-center justify-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
            sendAllDays
              ? 'bg-rune/20 text-rune border border-rune/30'
              : 'text-mist hover:text-parchment border border-transparent'
          }`}
        >
          <Layers size={12} />
          Full Series
        </button>
      </div>

      {/* Day selector or count selector */}
      {!sendAllDays ? (
        <div>
          <div className="text-mist text-[10px] uppercase tracking-wide mb-2">Select Day</div>
          <div className="flex flex-wrap gap-1.5">
            {Array.from({ length: totalDays }, (_, i) => (
              <button
                key={i}
                onClick={() => onDaySelect(i)}
                className={`w-8 h-8 rounded-lg text-xs font-medium transition-all ${
                  selectedDay === i
                    ? 'bg-rune text-night'
                    : 'bg-stone/20 text-mist hover:bg-stone/30 hover:text-parchment'
                }`}
              >
                {i}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <div>
          <div className="text-mist text-[10px] uppercase tracking-wide mb-2">Days to Send</div>
          <div className="flex items-center gap-3">
            <input
              type="range"
              min={1}
              max={totalDays}
              value={sendCount}
              onChange={(e) => onSendCountChange(Number(e.target.value))}
              className="flex-1 accent-rune"
            />
            <div className="flex items-baseline gap-1">
              <span className="text-parchment text-lg font-medium w-6 text-right">{sendCount}</span>
              <span className="text-mist/60 text-xs">/ {totalDays}</span>
            </div>
          </div>
          <div className="flex gap-1 mt-2">
            {Array.from({ length: totalDays }, (_, i) => (
              <div
                key={i}
                className={`flex-1 h-1.5 rounded-full transition-colors ${
                  i < sendCount ? 'bg-rune' : 'bg-stone/30'
                }`}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
